import { useState } from "react";
import {
  Container,
  Box,
  Text,
  get,
  Image,
  Flex,
  Button,
  Heading,
  Spinner,
} from "theme-ui";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { ContactForm, Modal } from "src/components";
import check from "src/assets/images/check_icon.png";
import { viewVariants } from "src/utils";
import { sendEmail, templates } from "src/services/email";
import { ContactFormValues } from "src/components/molecules/ContactForm/ContactForm.d";

export const Contact = () => {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [resetForm, setResetForm] = useState(false);
  const [error, setError] = useState(false);
  const { t } = useTranslation();

  const handleSendContactEmail = async (data: ContactFormValues) => {
    try {
      setError(false);
      setResetForm(false);
      setIsLoading(true);
      setShowModal(true);
      await sendEmail(templates.contact(data));
      setResetForm(true);
    } catch (error) {
      console.error({ error });
      setError(true);
      setShowModal(false);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <motion.div
      variants={viewVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        borderRadius="20px"
      >
        {isLoading && (
          <Flex
            sx={{
              px: 8,
              py: 9,
            }}
          >
            <Spinner />
          </Flex>
        )}
        {!isLoading && !error && (
          <Flex
            sx={{
              p: 5,
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Image src={check} sx={{ width: "4rem" }} />
            <Heading as="h1" sx={{ fontSize: 4, mt: 6 }}>
              {t("contact.contact_success.title")}
            </Heading>
            <Text
              sx={{
                fontSize: 3,
                mt: 3,
                mb: 5,
                textAlign: "center",
                whiteSpace: "pre-wrap",
              }}
            >
              {t("contact.contact_success.text")}
            </Text>
            <Button
              onClick={() => setShowModal(false)}
              sx={{ bg: "accent", width: "100%" }}
            >
              {t("copy.btns.conclude")}
            </Button>
          </Flex>
        )}
      </Modal>
      <Container
        as="main"
        sx={{
          p: 4,
          maxWidth: (theme) => get(theme, "breakpoints.1"),
        }}
      >
        <Box
          sx={{
            mb: [4, 5, 6],
            mt: [5, 6, 7],
          }}
        >
          <Text
            as="h1"
            sx={{
              fontFamily: "heading",
              textAlign: "center",
              fontWeight: 800,
              display: "block",
              fontSize: [5, 5, 7],
              mb: [3, 3, 4],
            }}
          >
            {t("contact.title")}
          </Text>
          <Text
            as="p"
            sx={{
              fontSize: [2, 2, 3],
              display: "block",
              textAlign: "center",
              px: [2, 2, 10],
              mb: [5, 7],
            }}
          >
            {t("contact.text")}
          </Text>
        </Box>

        <Box sx={{ px: [0, 5] }}>
          <ContactForm reset={resetForm} onSubmit={handleSendContactEmail} />
        </Box>
      </Container>
    </motion.div>
  );
};
